import { schUnitRateModels } from '@aloft/toolkit-shared';
import { Flex, IconButton } from '@aloft/toolkit-sui';

import { useState } from 'react';
import { useParams } from 'react-router';

import { IndicatedValue } from '../../../components/IndicatedValue.tsx';
import { SettingsControls } from '../../../components/Settings/SettingsControls.tsx';
import { useGetTkv2UnitRateModelsAPI } from '../../../hooks/api/toolkitComponents.ts';
import {
  selectHasArvOption,
  selectSalesComparisonApproach,
} from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { RegressionAnalysisModal } from '../../adjustmentsGrid/modals/RegressionAnalysisModal.tsx';
import { EstimatedROIBanner } from '../../featureGrid/components/EstimatedROIBanner.tsx';

export const AdjustmentsModuleTitle = () => {
  const hasArvOption = useAppSelector(selectHasArvOption);
  const hasUnitRate = useAppSelector(selectSalesComparisonApproach) === 'unit_rate';

  const CostBanner = hasArvOption ? EstimatedROIBanner : IndicatedValue;

  const { orderId: orderID } = useParams<{ orderId: string }>();
  const unitRateModelsQuery = useGetTkv2UnitRateModelsAPI(
    { pathParams: { orderID: orderID! } },
    { staleTime: Infinity },
  );
  const unitRateModels = schUnitRateModels.safeParse(unitRateModelsQuery.data?.body).data ?? null;
  const isRegressionAvailable = unitRateModels?.regression?.status === 'success';

  const [isModalOpen, setIsModalOpen] = useState(false);

  if (hasUnitRate) {
    return (
      <>
        <Flex justifyContent="space-between">
          <Flex gap="12px">
            <IconButton
              icon="line-chart"
              size="xs"
              iconSize="md"
              ariaLabel="Open regression analysis model"
              text="Regression Modal"
              textColor="buttonDefault"
              variant="secondary"
              __dangerDoNotUseSx={{ width: 'fit-content' }}
              disabled={!isRegressionAvailable}
              onClick={() => setIsModalOpen(true)}
            />
          </Flex>
          <Flex alignItems="center" gap=".75rem">
            <SettingsControls />
          </Flex>
        </Flex>
        <RegressionAnalysisModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </>
    );
  }

  return (
    <Flex
      marginBottom=".5rem"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
    >
      <CostBanner />
      <SettingsControls />
    </Flex>
  );
};
